import cn from "classnames";

import { getAdjustedValue } from "./DetailedTable.helpers";

import { Table } from "shared/ui/components/Table";
import { Typography } from "shared/ui/components/Typography";

import styles from "./DetailedTable.module.scss";

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const value = cellType !== "boolean" ? item[key] : item[key] || false;
      const adjustedValue = getAdjustedValue(value, cellType);
      const summeRow = item.year === "Summe";

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{ minWidth, maxWidth, justifyContent: justifyContent }}
        >
          <Typography
            className={cn(styles.text, { [styles.summeText]: summeRow })}
            variant="numbers"
          >
            {adjustedValue}
          </Typography>
        </div>
      );
    }
  }
};

const UserCalculationTable = ({
  className,
  innerClassName,
  title,
  data,
  columns,
  cellRenderer,
  bottomText,
}: any) => {
  const customCellRenderer = cellRenderer || _cellRenderer;

  return (
    <div className={cn(styles.root, className)}>
      <Typography variant="bodyL" weight="semiBold" className={styles.title}>
        {title}
      </Typography>
      <Table
        className={cn(styles.table, innerClassName)}
        headerClassName={styles.tableHeader}
        headerCellClassName={styles.tableHeaderCell}
        rowClassName={styles.tableRow}
        cellClassName={styles.tableCell}
        headerTextClassName={styles.tableHeaderText}
        headerTextProps={{
          variant: "bodyM",
        }}
        sticky={false}
        data={data}
        columns={columns}
        cellRenderer={(props) => customCellRenderer(props)}
      />
      {bottomText && (
        <Typography
          variant="bodyS"
          weight="regular"
          withHTML={true}
          className={styles.bottomText}
        >
          {bottomText}
        </Typography>
      )}
    </div>
  );
};

export default UserCalculationTable;
